import { useInView } from 'react-intersection-observer';

import type { InfiniteData, UseInfiniteQueryResult } from '@tanstack/react-query';

import { Spinner } from '@uikit';

interface InfiniteQueryStateProps {
  query: UseInfiniteQueryResult<InfiniteData<any, unknown>, unknown>;
}

const InfiniteQueryState = ({ query }: InfiniteQueryStateProps) => {
  const {
    data: { pages = [] } = {},
    isLoading,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage,
    isError,
  } = query;
  const { ref } = useInView({
    onChange: (inView) =>
      inView && !isError && !isLoading && !isFetchingNextPage && fetchNextPage(),
  });

  return (
    <div className="w-full flex flex-col flex-grow flex-shrink-0 items-center justify-center gap-2 py-6">
      {(isLoading || hasNextPage) && (
        <>
          {isError && (
            <>
              <span className="text-neutral-500">Couldn&apos;t load more offers</span>
              <button onClick={() => fetchNextPage()} className="button button-outline-secondary">
                Try Again
              </button>
            </>
          )}

          {!isError && (
            // Key is added to trigger in view cb again if component is already in view
            <Spinner key={pages.length} ref={ref} />
          )}
        </>
      )}

      {!isLoading && !hasNextPage && (
        <span className="text-neutral-500">
          {isError && "Couldn't load more offers"}
          {!hasNextPage && !!pages.length && "That's all for now!"}
          {!hasNextPage && !isError && !pages.length && 'No offers available at the moment.'}
        </span>
      )}
    </div>
  );
};

export default InfiniteQueryState;
